import { createSlice } from '@reduxjs/toolkit';
import { userData } from '../apis/userData';
const initialState = {
    userData: {},
    status: 'idle',
    error: null,
    activeRequestId: null,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: { 
        setSessionAccount: (state, action) => {
            const account = action.payload;
            if (!account?.id && !account?._id) return;
            const id = String(account._id || account.id);
            const previous = state.userData?.user;
            const sameAccount = previous && String(previous._id || previous.id) === id && previous.type === account.type;
            state.userData = { user: { ...(sameAccount ? previous : {}), ...account, _id: id } };
            state.status = 'succeeded';
            state.error = null;
            state.activeRequestId = null;
        },
        logout: (state) => {
        state.userData = {};
        state.status = 'idle';
        state.error = null;
        state.activeRequestId = null;
    },},
    extraReducers: (builder) => {
        builder
            .addCase(userData.pending, (state, action) => {
                state.status = 'loading';
                state.activeRequestId = action.meta.requestId;
            })
            .addCase(userData.fulfilled, (state, action) => {
                if (state.activeRequestId !== action.meta.requestId) return;
                state.status = 'succeeded';
                state.userData = action.payload;
                state.activeRequestId = null;
            })
            .addCase(userData.rejected, (state, action) => {
                if (state.activeRequestId !== action.meta.requestId) return;
                state.status = 'failed';
                state.error = action.error.message;
                state.activeRequestId = null;
            })
           
    },
});
export const { logout, setSessionAccount } = userSlice.actions;
  export default userSlice.reducer;
